<script setup lang="ts">
import type { Manifest } from '@clovyr/pollen/manifest';

import { usePayments } from '@/composables/usePayments';
import LaunchMarketing from '@/views/Settings/AuthForms/LaunchMarketing.vue';

import Modal from '../elements/Modal.vue';

import CardPaymentButton from './CardPaymentButton.vue';
import MarketingFeatureList from './MarketingFeatureList.vue';

const { app } = defineProps<{ app: Manifest }>();

const { captureLaunchPayment, hasPaymentOnFile } = usePayments();

const onClickPay = async () => {
  await captureLaunchPayment(app.metadata.id);
};
</script>

<template>
  <Modal class="sub-modal" theme="transparent" size="narrow" @close="$emit('close')" max-on-mobile>
    <template #body>
      <div class="container">
        <MarketingFeatureList />
        <div class="payment-modal-marketing">
          <LaunchMarketing panel :buttons="hasPaymentOnFile" :app="app" @close="$emit('close')" />
          <div v-if="!hasPaymentOnFile" class="payment-options">
            <CardPaymentButton @click="onClickPay" />
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.payment-modal-marketing {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payment-options {
  margin-top: 2rem;
}
.container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
}
</style>
